// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ebb0740d","455":"4d50eb8a","625":"34a6b527","813":"c024af92","977":"72d370f6"}[chunkId] + ".chunk.js";
};